export enum RESEND_PIN_SUBJECT {
  CONFIRM_EMAIL = 'CONFIRM_EMAIL',
  CONFIRM_PHONE_NUMBER = 'CONFIRM_PHONE_NUMBER',
}
